import { StarIcon } from '@heroicons/react/solid'

export default function Rating({ rating, maxRating = 5 }) {
    return (
        <div className="flex flex-row space-x-1">
            {[...Array(rating)].map((_, i) => (
                <StarIcon
                    className={'h-7 w-7 text-yellow-400'}
                    aria-hidden="true"
                    key={i}
                />
            ))}
            {[...Array(maxRating - rating)].map((_, i) => (
                <StarIcon
                    className={'h-7 w-7 text-neutral-300'}
                    aria-hidden="true"
                    key={i}
                />
            ))}
        </div>
    )
}
